import React from 'react';
import OrderLogListPageContainer from './OrderLogListPageContainer';

export class OrderLogListPage extends React.Component{
    render(){
        return(
            <OrderLogListPageContainer {...this.props}/>
        )
    }
}